import { useLocation } from "react-router-dom";
import "./Sidbar.css";
import { useTranslation } from "react-i18next";

import { IMAGES } from "../../../../assets/Images/Image";

import { NavItem } from "../navItem/NavItem";
import { MenuItemsManager } from "../../../../navigation/Routes";
import { useState } from "react";
import { GoSidebarCollapse, GoSidebarExpand } from "react-icons/go";

interface NavItemProps {
  isCollapsed?: boolean;
  onNavigate?: () => void;
  onToggleCollapse: () => void;
}
export const ManagerSideBar: React.FC<NavItemProps> = ({
  onNavigate,
  isCollapsed,
  onToggleCollapse,
}) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const [isStatsOpen, setIsStatsOpen] = useState(false);

  // Handle submenu toggle
  const toggleStats = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsStatsOpen(!isStatsOpen);
  };

  return (
    <div className={`mc-sidebar ${isCollapsed ? "collapsed" : ""}`}>
      {/* Collapse Toggle Button */}
      <div className="mchic-header">
        {!isCollapsed && (
          <img src={IMAGES.LOGO} alt="Logo" className="mchic-logo" />
        )}
        {/* Toggle button - now positioned absolutely in the header */}
        <button
          className="collapse-toggle"
          onClick={onToggleCollapse}
          aria-label={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          {isCollapsed ? (
            <GoSidebarCollapse size={20} />
          ) : (
            <GoSidebarExpand size={20} />
          )}
        </button>
      </div>

      <div className="seperator" />

      <ul
        className={`sidebar-menu ${
          isCollapsed ? "collapsed-item-container" : ""
        }`}
      >
        {MenuItemsManager.map((item) => (
          <NavItem
            key={item.path}
            path={item.path}
            icon={item.icon}
            label={t(`sidebar.${item.label}`)}
            isActive={pathname === item.path}
            isCollapsed={isCollapsed}
          />
        ))}
      </ul>
    </div>
  );
};
